<section class="page">
  <header class="page__header">
    <div>
      <h1>Konfiguration</h1>
      <p>Felder und Feldtexte verwalten.</p>
    </div>
    <button type="button" class="secondary" (click)="loadFields()">Aktualisieren</button>
  </header>

  <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>

  <section class="card admin-settings">
    <header class="card__header">
      <h2>Administrator</h2>
    </header>
    <label class="admin-settings__toggle">
      <input
        type="checkbox"
        [(ngModel)]="appSettings.aiJsonInputsEnabled"
        [disabled]="appSettingsLoading || appSettingsSaving"
        (change)="saveAppSettings()"
      />
      <span>ChatGPT- und JSON-Eingaben im Tradingtagebuch anzeigen</span>
    </label>
    <p class="admin-settings__hint">Standardmäßig ausgeblendet.</p>
  </section>

  <div class="detail-modal" *ngIf="detailText as text" role="dialog" aria-modal="true">
    <div class="detail-modal__backdrop" (click)="closeTextDetails()"></div>
    <div class="detail-modal__content">
      <header class="detail-modal__header">
        <div>
          <h2>{{ text.bezeichnung }}</h2>
          <p>{{ text.feldTextId }}</p>
        </div>
        <button type="button" class="secondary" (click)="closeTextDetails()" aria-label="Schließen">Schließen</button>
      </header>
      <section class="detail-modal__description">
        <h3>Beschreibung</h3>
        <p *ngIf="text.beschreibung?.trim(); else noDescription">{{ text.beschreibung }}</p>
        <ng-template #noDescription><p class="empty">Keine Beschreibung hinterlegt.</p></ng-template>
      </section>
      <section class="detail-modal__gallery">
        <h3>Medien</h3>
        <div class="media-tabs" *ngIf="detailTabs().length; else noMedia">
          <div class="media-tabs__nav" role="tablist" aria-label="Medien">
            <button
              type="button"
              class="media-tabs__tab"
              *ngFor="let tab of detailTabs()"
              [class.media-tabs__tab--active]="activeDetailTabId === tab.id"
              (click)="setActiveDetailTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
          <div class="media-tabs__body" *ngIf="activeDetailTab() as tab">
            <figure class="media-preview" *ngIf="tab.type === 'image' && tab.image">
              <div class="media-preview__actions">
                <button type="button" class="danger" (click)="removeDetailImage(tab.image.id)">Bild löschen</button>
              </div>
              <img [src]="tab.image.imageDataUrl" [alt]="tab.image.name" />
              <figcaption>{{ tab.image.name }}</figcaption>
            </figure>
            <div class="link-preview" *ngIf="tab.type === 'links'">
              <div class="link-preview__item" *ngFor="let link of detailLinks()">
                <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                  {{ link.label }}
                </a>
                <button type="button" class="danger" (click)="removeDetailLink(link.id)">Löschen</button>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noMedia><p class="empty">Keine Bilder oder Links hinterlegt.</p></ng-template>
      </section>
    </div>
  </div>

  <div class="layout">
    <section class="card">
      <header class="card__header">
        <h2>Felder</h2>
      </header>

      <div class="table-wrap" *ngIf="fields.length; else noFields">
        <table>
          <thead>
            <tr>
              <th>Feld-ID</th>
              <th>Bezeichnung</th>
              <th class="actions">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let field of fields"
              [class.selected]="isSelected(field)"
              (click)="selectField(field)"
            >
              <td>{{ field.feldId }}</td>
              <td>{{ field.feldBezeichnung }}</td>
              <td class="actions">
                <button type="button" class="secondary" (click)="$event.stopPropagation(); startEdit(field)">Bearbeiten</button>
                <button
                  type="button"
                  class="danger"
                  *ngIf="confirmDeleteId !== field.feldId"
                  (click)="$event.stopPropagation(); requestDelete(field)"
                >Löschen</button>
                <span class="delete-confirm" *ngIf="confirmDeleteId === field.feldId">
                  <button type="button" class="danger" (click)="$event.stopPropagation(); deleteField(field)">Bestätigen</button>
                  <button type="button" class="secondary" (click)="$event.stopPropagation(); cancelDelete()">Abbrechen</button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noFields>
        <p class="empty" *ngIf="!isLoading">Noch keine Felder vorhanden.</p>
      </ng-template>
      <p class="empty" *ngIf="isLoading">Lade Felder…</p>
    </section>

    <section class="card">
      <header class="card__header">
        <h2>{{ editMode === 'create' ? 'Neues Feld' : 'Feld bearbeiten' }}</h2>
      </header>

      <form class="form" (ngSubmit)="saveField()">
        <label>
          Feld-ID
          <input
            type="text"
            name="feldId"
            [(ngModel)]="formModel.feldId"
            maxlength="64"
            [readonly]="editMode === 'update'"
            required
          />
        </label>
        <label>
          Bezeichnung
          <input
            type="text"
            name="feldBezeichnung"
            [(ngModel)]="formModel.feldBezeichnung"
            maxlength="255"
            required
          />
        </label>

        <div class="form__actions">
          <button type="submit" [disabled]="!canSave()">{{ editMode === 'create' ? 'Anlegen' : 'Speichern' }}</button>
          <button type="button" class="secondary" (click)="startCreate()">Zurücksetzen</button>
        </div>
      </form>
    </section>
  </div>

  <div class="layout">
    <section class="card">
      <header class="card__header">
        <h2>Feldtexte {{ selectedFieldId ? '(' + selectedFieldId + ')' : '' }}</h2>
      </header>

      <p class="empty" *ngIf="!selectedFieldId">Wähle ein Feld, um Feldtexte zu verwalten.</p>
      <p class="empty" *ngIf="selectedFieldId && fieldTextsLoading">Lade Feldtexte…</p>

      <div class="table-wrap" *ngIf="selectedFieldId && !fieldTextsLoading">
        <table>
          <thead>
            <tr>
              <th>Feldtext-ID</th>
              <th>Bezeichnung</th>
              <th>Anzeigen</th>
              <th>CRV</th>
              <th>Marge</th>
              <th>Kosten / Einheit</th>
              <th>Inhalt</th>
              <th class="actions">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let text of selectedFieldTexts">
              <td>{{ text.feldTextId }}</td>
              <td>{{ text.bezeichnung }}</td>
              <td>{{ text.anzeigen === false ? 'Nein' : 'Ja' }}</td>
              <td>{{ text.crvGrund || '-' }}</td>
              <td>{{ text.marge || '-' }}</td>
              <td>{{ text.kostenProEinheit || '-' }}</td>
              <td>
                <span class="content-pill" *ngIf="text.beschreibung?.trim()">Text</span>
                <span class="content-pill" *ngIf="textImageCount(text)">Bilder: {{ textImageCount(text) }}</span>
                <span class="content-pill" *ngIf="textLinkCount(text)">Links: {{ textLinkCount(text) }}</span>
                <span class="empty" *ngIf="!hasTextDetails(text)">-</span>
              </td>
              <td class="actions">
                <button type="button" class="secondary" [disabled]="!hasTextDetails(text)" (click)="openTextDetails(text)">Details</button>
                <button type="button" class="secondary" (click)="startTextEdit(text)">Bearbeiten</button>
                <button
                  type="button"
                  class="danger"
                  *ngIf="confirmDeleteTextId !== text.feldTextId"
                  (click)="requestDeleteText(text)"
                >Löschen</button>
                <span class="delete-confirm" *ngIf="confirmDeleteTextId === text.feldTextId">
                  <button type="button" class="danger" (click)="deleteFieldText(text)">Bestätigen</button>
                  <button type="button" class="secondary" (click)="cancelDeleteText()">Abbrechen</button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="empty" *ngIf="!selectedFieldTexts.length">Keine Feldtexte vorhanden.</p>
      </div>
    </section>

    <section class="card">
      <header class="card__header">
        <h2>{{ textEditMode === 'create' ? 'Neuer Feldtext' : 'Feldtext bearbeiten' }}</h2>
      </header>

      <form class="form" (ngSubmit)="saveFieldText()">
        <label>
          Feldtext-ID
          <input
            type="text"
            name="feldTextId"
            [(ngModel)]="textFormModel.feldTextId"
            maxlength="64"
            [readonly]="textEditMode === 'update'"
            required
          />
        </label>
        <label>
          Bezeichnung
          <input
            type="text"
            name="feldTextBezeichnung"
            [(ngModel)]="textFormModel.bezeichnung"
            maxlength="255"
            required
          />
        </label>
        <label>
          Anzeigen
          <select name="feldTextAnzeigen" [(ngModel)]="textFormModel.anzeigen">
            <option [ngValue]="true">Ja</option>
            <option [ngValue]="false">Nein</option>
          </select>
        </label>
        <label>
          CRV Grund
          <input
            type="number"
            name="feldTextCrvGrund"
            [(ngModel)]="textFormModel.crvGrund"
            step="0.01"
            min="0"
            placeholder="Leer = 1:3"
          />
        </label>
        <label>
          Marge
          <input
            type="number"
            name="feldTextMarge"
            [(ngModel)]="textFormModel.marge"
            step="0.01"
            min="0"
          />
        </label>
        <label>
          Kosten pro Einheit
          <input
            type="number"
            name="feldTextKostenProEinheit"
            [(ngModel)]="textFormModel.kostenProEinheit"
            step="0.01"
            min="0"
          />
        </label>
        <label>
          Beschreibung
          <textarea
            name="feldTextBeschreibung"
            [(ngModel)]="textFormModel.beschreibung"
            rows="6"
            placeholder="Mehrzeilige Beschreibung, Regeln oder Hinweise"
          ></textarea>
        </label>
        <label>
          Bilder
          <div
            class="image-dropzone"
            role="button"
            tabindex="0"
            (dragover)="onTextImageDragOver($event)"
            (dragleave)="onTextImageDragLeave($event)"
            (drop)="handleTextImageDrop($event)"
            (click)="textImageInput?.click()"
            (keydown.enter)="$event.preventDefault(); textImageInput?.click()"
            (keydown.space)="$event.preventDefault(); textImageInput?.click()"
            (paste)="handleTextImagePaste($event)"
            [class.image-dropzone--active]="textImageDropActive"
            aria-label="Bilder hier ablegen, auswählen oder einfügen"
          >
            <input
              type="file"
              accept="image/*"
              multiple
              #textImageInput
              class="visually-hidden"
              (change)="handleTextImageFileSelection($event)"
              aria-hidden="true"
              tabindex="-1"
            />
            <span>Bilder hierher ziehen, klicken oder per Strg+V einfügen.</span>
            <small *ngIf="textImageUploadError">{{ textImageUploadError }}</small>
          </div>
        </label>
        <div class="image-list" *ngIf="textFormImages.length">
          <div class="image-list__item" *ngFor="let image of textFormImages">
            <img [src]="image.imageDataUrl" [alt]="image.name" />
            <span>{{ image.name }}</span>
            <button type="button" class="danger" (click)="removeTextImage(image.id)">Entfernen</button>
          </div>
        </div>
        <div class="link-editor">
          <div class="link-editor__title">Links</div>
          <div class="link-editor__row">
            <input
              type="text"
              name="newTextLinkLabel"
              [(ngModel)]="newTextLinkLabel"
              placeholder="Bezeichnung"
            />
            <input
              type="url"
              name="newTextLinkUrl"
              [(ngModel)]="newTextLinkUrl"
              placeholder="https://..."
            />
            <button type="button" class="secondary" (click)="addTextLink()" [disabled]="!newTextLinkUrl.trim()">Hinzufügen</button>
          </div>
          <div class="link-list" *ngIf="textFormLinks.length">
            <div class="link-list__item" *ngFor="let link of textFormLinks">
              <a [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
              <button type="button" class="danger" (click)="removeTextLink(link.id)">Entfernen</button>
            </div>
          </div>
        </div>

        <div class="form__actions">
          <button type="submit" [disabled]="!canSaveText()">{{ textEditMode === 'create' ? 'Anlegen' : 'Speichern' }}</button>
          <button type="button" class="secondary" (click)="startTextCreate()">Zurücksetzen</button>
        </div>
      </form>
    </section>
  </div>
</section>
